















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ReportRSRow } from '../table-data/ReportRsRow';
import { CertificateLevel, ClassificationType } from '../../../common/types/roots/fields';
import { Classificator } from '../../../common/types/Classificator';
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"

interface KbkColumn {
    label: string
    incomeKey?: string
    expenseKey?: string
}

@Component({})
export default class ReportRs extends Vue {

    @Prop({ type: Array, required: true })
    public tableData!: ReportRSRow[]

    @Prop({ type: String, required: true })
    private readonly classificationType!: ClassificationType

    @Prop({ type: Array, required: true, default: () => [] })
    private readonly propClassificators!: Classificator[]

    @Prop({ type: Array, default: () => [] })
    private readonly propExpenseClassificators!: Classificator[]

    @Prop({ type: Boolean, default: true })
    private readonly isTree!: boolean

    @Prop({ type: String, default: 'UO' })
    private readonly certificateLevel!: CertificateLevel

    private created() {
        this.handlePageChange(1)
    }

    get isGuLevel(): boolean {
        return this.certificateLevel === 'GU'
    }

    private readonly i18nBase = 'modules.budget_execution_monitoring.reports_constructor'

    get columnsNameMap(): Record<string, string> {
        const t = (key: string) => this.$t(`${this.i18nBase}.${key}`) as string
        return {
            'spr': t('rs.spr'),
            'spr_type': t('rs.spr_type'),
            'gu_name': t('rs.gu_name'),
            'description': t('rs.basis'),

            'kat': t('kat'),
            'cls': t('cls'),
            'pcl': t('pcl'),
            'spf': t('spf'),

            'gr': t('gr'),
            'pgr': t('pgr'),
            'abp': t('abp'),
            'prg': t('prg'),
            'ppr': t('ppr'),

            'total_amount': t('total_amount'),
            'month1': t('month1'),
            'month2': t('month2'),
            'month3': t('month3'),
            'month4': t('month4'),
            'month5': t('month5'),
            'month6': t('month6'),
            'month7': t('month7'),
            'month8': t('month8'),
            'month9': t('month9'),
            'month10': t('month10'),
            'month11': t('month11'),
            'month12': t('month12'),
        }
    }

    get kbkColumns(): KbkColumn[] {
        const incomes  = this.propClassificators.filter(it => it.active).map(it => it.key)
        const expenses = this.propExpenseClassificators.filter(it => it.active).map(it => it.key)

        const span = Math.max(incomes.length, expenses.length)
        return Array.from({ length: span }, (_, i) => {
            const iKey   = incomes[i]
            const eKey   = expenses[i]
            const iLabel = iKey ? (this.columnsNameMap[iKey] ?? iKey) : ''
            const eLabel = eKey ? (this.columnsNameMap[eKey] ?? eKey) : ''
            const label  = iKey && eKey ? `${iLabel} / ${eLabel}` : (iLabel || eLabel)
            return { label, incomeKey: iKey, expenseKey: eKey }
        })
    }

    get visibleRows(): ReportRSRow[] {
        if (this.classificationType === 'MIXED') {
            return this.isTree
                ? this.tableData.filter(row => row.type !== 'classificator_flat')
                : this.tableData.filter(row => row.type !== 'classificator')
        }
        if (this.isTree) return this.tableData
        return this.tableData.filter(row => row.type !== 'classificator')
    }

    get totalRows() {
        return this.visibleRows.length
    }

    public perPage = 200
    public currentPage = 1
    public currentItems: ReportRSRow[] = []

    public handlePageChange(page: number) {
        const indexedPage = page - 1
        this.currentPage = page
        const startIndex = indexedPage * this.perPage
        const endIndex   = startIndex + this.perPage
        this.currentItems = this.visibleRows.slice(startIndex, endIndex)
    }

    public formatDigitsGrouping = formatDigitsGrouping
}
